import React, { useState, useEffect, useMemo } from "react";
import { Routes, Route, useSearchParams } from "react-router-dom";

import { ErrorBoundary } from "react-error-boundary";
import App from "./App";
import PublicPuzzle from "./PublicPuzzleApp";
// import UnsubscribeEmail from "./Components/UnsubscribeEmail";
// import sadNewsie from "./Assets/sad-newsie-192-removebg.png";

import "./Router.css";
import PublicPuzzleApp from "./PublicPuzzleApp";

const myErrorHandler = () => {
  localStorage.clear();
};

const ErrorComponent = () => {
  // Purge localStorage and reload... maybe tell users to reload instead??
  setTimeout(1000, () => window.location.reload());
  return (
    <div>
      {/* <img src={sadNewsie} /> */}
      <br />
      oops...
    </div>
  );
};

const Router = () => {
  const [rotatePhone, setRotatePhone] = useState(false);

  const [searchParams] = useSearchParams();

  const source = searchParams.get("refSource");
  const referralCode = searchParams.get("referralCode");

  if (source) localStorage.setItem("refSource", source);
  if (referralCode) localStorage.setItem("referralCode", referralCode);

  const resize = () => {
    if (window.matchMedia("(orientation: portrait)").matches) {
      setRotatePhone(false);
    }
    if (window.matchMedia("(orientation: landscape)").matches) {
      // console.log("orientation: landscape");
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        // true for mobile device
        setRotatePhone(true);
      }
    }
  };
  window.addEventListener("resize", resize);
  console.log("Router.js");
  return (
    <ErrorBoundary onError={myErrorHandler} fallback={<ErrorComponent />}>
      {rotatePhone ? (
        <div className="landscape-layout">
          {/* <img src={sadNewsie} /> */}
          <div className="landscape-layout-text-container">
            Rotate Your Phone!
          </div>
        </div>
      ) : (
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/:unauthedPage" element={<App />} />
      <Route
        path="/portal/account/email/verify/:emailVerificationToken/:email"
        element={<App />}
      />
      <Route path="/play/puzzle/:puzzleId" element={<PublicPuzzleApp />} />
    </Routes>
      )}
    </ErrorBoundary>
  );
};
export default Router;
